const theme = {

    // Main colors
    $color_1: `#3C3C3C`, // 12
    $color_2: `#FFFFFF`, //25
    $color_3: `#000000`,// 27
    $color_4: `#FDD907`,// 60
    $color_5: `#019A39`,// 61
    $color_6: `#656565`,// 62
    $color_7: `#b13333`,// 63
	$color_8: `#dedede`,
    $color_9: `#166831`,
    $color_10: "#DA291C" // unique brand color
};

// Cashout full & partial for terminals

theme['$cashoutPanelBackgroundColor'] = theme['$color_1'];
theme['$cashoutFormHeaderBorderColor'] = theme['$color_4'];
theme['$cashoutFormHeaderTextColor'] = theme['$color_2'];
theme['$cashoutFormMainTextColor'] = theme['$color_2'];
theme['$cashoutSliderActiveColor'] = theme['$color_5'];
theme['$cashoutSliderNotActiveColor'] = theme['$color_6'];
theme['$cashoutSliderLabelColor'] = theme['$color_2'];
theme['$cashoutAmountButtonBackgroundColor'] = theme['$color_6'];
theme['$cashoutAmountInputBackgroundColor'] = theme['$color_2'];
theme['$cashoutAmountInputColor'] = theme['$color_3'];

// Cashout code confirmation

theme['$cashoutCodeHeaderBackgroundColor'] = theme['$color_8'];
theme['$cashoutCodePanelBackgroundColor'] = theme['$color_2'];
theme['$cashoutCodeInputBackgroundColor'] = theme['$color_2'];
theme['$cashoutCodeInputTextColor'] = theme['$color_3'];
theme['$cashoutCodeButtonTextColor'] = theme['$color_2'];
theme['$cashoutCodeButtonBackgroundColor'] = theme['$color_9'];
theme['$cashoutConfirmTextMessageColor'] = theme['$color_2'];

// gambling controls
theme['$gamblingControlsPrimaryColor'] = theme['$color_10'];

// CMS Menu
theme["cmsMenuBackgroundColor"] = theme["$color_10"];
theme["cmsMenuTextColor"] = theme["$color_2"];
theme["cmsMenuTextColorActive"] = theme["$color_4"];

export default theme;